import React from 'react';
import Main from '../Components/Main'
import RequestFeedButton from '../Components/RequestFeedButton';
import Seo from '../Components/Seo';

const Home = () => {
  return (
    <Main>
      <Seo title="Home" />

      <div className="container w-full mx-auto overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-10 items-center justify-items-center">
          <div className="max-w-lg p-6 mt-2 md:justify-self-start">
            <h1 className="my-5 leading-normal text-4xl lg:text-5xl">
              <i className="font-semibold">Welcome to </i>
              <span className="font-bold text-lime-500 text-7xl">Goracle</span>
            </h1>
            <p className="leading-normal">
              This project aims to provide a price, weather, sports and other types
              of feeds to dapps created on the Algorand ecosystem
            </p>
            <div className="mt-5">
              <a href="https://www.goracle.io/contact" target="_blank" 
                rel="noreferrer" className="button-primary">
                  Contact Us
              </a>
            </div>
          </div>

          <div className="max-w-md p-4 mt-2 flex justify-center">
            <img src="/images/robot-01.png" alt="Robot image" />
          </div>
        </div>
      </div>

      <section className="bg-gray-100 text-neutral py-8">
        <div className="container max-w-5xl mx-auto m-8">
          <div className="flex flex-wrap flex-col-reverse sm:flex-row items-center">
            <div className="w-full sm:w-1/2 p-6">
              <img
                className="object-cover w-full md:w-2/3"
                src="/images/online-report-flatline.svg"
                alt="Feed consumer image" />
            </div>
            <div className="w-5/6 sm:w-1/2 p-6">
              <h2 className="text-3xl leading-none">
                <i className="font-semibold">Feed </i>
                <span className="font-bold">Consumer</span>
              </h2>
              <p className="mt-3">
                To consume these feeds, navigate to your page, find the contract of the relevant feed.
                At this time, the values can simply be read from the global state of the contract.
              </p>
              <div className="mt-5">
                <RequestFeedButton url="/feeds" title="Feeds" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-8">
        <div className="container max-w-5xl mx-auto m-8">
          <div className="flex flex-wrap sm:flex-row items-center">
            <div className="w-5/6 sm:w-1/2 p-6">
              <h2 className="text-3xl leading-none">
                <i className="font-semibold">Feed </i>
                <span className="font-bold">Provider</span>
              </h2>
              <p className="mt-3">
                To provide feed, navigate to a feed page, and click &quot;become an oracle&quot;.
                Instead of running nodes like oracle providers on other chains, you simply
                provide a REST API endpoint, and Goracle nodes will do the rest. You will
                find information on how your feed should respond to queries. Eventually,
                there will be a deposit required, and awards will be paid out to the submitter&apos;s address.
              </p>
              <div className="mt-5">
                <RequestFeedButton url="/feeds" title="Feeds" />
              </div>
            </div>
            <div className="w-full sm:w-1/2 p-6">
              <img
                className="object-cover w-full"
                src="/images/frame-2.png"
                alt="Feed provider image" />
            </div>
          </div>
        </div>
      </section>
    </Main>
  );
}

export default Home;
